import { useSearchParams } from "react-router-dom";
import LandingPage from "@features/landingPage/LandingPage";
import FormAssignmentsWrapper from "@features/formAssignments/FormAssignmentsWrapper";

const FastrLoginUrlRouter = () => {
  const [searchParams] = useSearchParams();
  const hasFormParams =
    searchParams.has("patientId") && searchParams.has("formAssignmentId");

  return hasFormParams ? <FormAssignmentsWrapper /> : <LandingPage />;
};

export default FastrLoginUrlRouter;
